export default __webpack_public_path__ + "static/graph_vertical-2a2af063af8f2f5835d43eb3904432e2.svg";